const tags=[
    {name:"implementation"},
    {name:"math"},
    {name:"greedy"},
    {name:"dp"},
    {name:"data structure"},
    {name:"brute force"},
    {name:"constructive algorithms"},
    {name:"graphs"},
    {name:"sortings"},
    {name:"binary search"},
    {name:"dfs and similar"},
    {name:"trees"},
    {name:"string"},
    {name:"number theory"},
    {name:"*special"},
    {name:"geometry"},
    {name:"bitmasks"},
    {name:"two pointer"},
    {name:"dsu"},
    {name:"shortest paths"},
    {name:"probabilities"},
    {name:"divide and conquer"},
    {name:"hashing"},
    {name:"games"},
    {name:"flows"},
    {name:"interactive"},
    {name:"string suffix structure"},
    {name:"fft"},
    {name:"graph matchings"},
    {name:"ternary search"},
    {name:"expression parsing"},
    {name:"mee-in-the-middle"},
    {name:"2-sat"},
    {name:"chinese remainder theorem"},
    {name:"schedules"}
];

export default tags;